/**
  * @function evaluate - evaluate taggedFieldOptionsBehavior
  */

export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, evaluateSource) => {
  const tagOptions = await evaluateSource({
    type: 'getCacheValueBehavior',
    name: 'tag/options'
  });
  const {
    importFormType
  } = content;
  const [formTypeIdentifier] = Object.keys(importFormType);
  const {
    children
  } = tagOptions ? tagOptions[formTypeIdentifier] : {
    children: []
  };
  return children;
};
export default {
  evaluate
};